<template>
  <div class="meApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" @resize="handleResize">
    <headComponent></headComponent>
    <div style="height:25px"></div>
    <div class="use" :style="'background:url('+meImg+') no-repeat;background-size:cover;'">
      <div style="height:30px"></div>
      <div class="useInfo">
        <img class="avatar" :src="userData.avatar">
        <div class="name">
          <h2>{{userData.username}}</h2>
          <p>
            <span style="padding-right:8px"  v-if="rs.phone != ''">{{rs.phone}}</span>
            <font @click="$router.push('mjukaindy')"><i class="el-icon-edit"></i>实名认证</font>
          </p>
        </div>
        
      </div>
      <ul>
        <li>
          <span>卡使用次数</span>
          <font>{{rs.ryUser}}</font>
        </li>
        <li>
          <span>账号余额</span>
          <font>{{rs.wallet}}</font>
        </li>
        <li>
          <span>参与活动</span>
          <font>{{rs.atotal}}</font>
        </li>
      </ul>
    </div>
    <div class="money">
      <div class="left">账户总余额 <font>￥{{rs.wallet}}</font></div>
      <div class="right">
        <a @click="$router.push('mwallet')">去提现</a>
      </div>
    </div>
    <div class="order">
      <h2>我的活动线路
        <a @click="$router.push('mjukaorder?id=0')">查看订单<i class="el-icon-arrow-right"></i></a>
      </h2>
      <div class="order-list">
        <div class="item" @click="$router.push('mjukaorder?id=0')">
          <img src="~assets/img3/icon11.png">
          <p>全部</p>
        </div>
        <div class="item" @click="$router.push('mjukaorder?id=1')">
          <img src="~assets/img3/icon8.png">
          <p>待预约</p>
        </div>
        <div class="item" @click="$router.push('mjukaorder?id=2')">
          <img src="~assets/img3/icon9.png">
          <p>已报名</p>
          <b v-if="rs.bm > 0">{{rs.bm}}</b>
        </div>
        <div class="item" @click="$router.push('mjukaorder?id=3')">
          <img src="~assets/img3/icon10.png">
          <p>已核销</p>
          <b v-if="rs.hx > 0">{{rs.hx}}</b>
        </div>
      </div>
    </div>

    <div class="server">
      <h2>我的服务</h2>
      <dl>
        <dd @click="$router.push('gatherorder')">
          <a href="javascript:;">
            <img src="~assets/img3/7.png">
            <p>悠乐聚卡</p>
          </a>
        </dd>
        <dd @click="$router.push('mwallet')">
          <a href="javascript:;">
            <img src="~assets/img3/3.png">
            <p>我的钱包</p>
          </a>
        </dd>
        <dd @click="$router.push('mjukaindy')">
          <a href="javascript:;">
            <img src="~assets/img3/1.png">
            <p>个人信息</p>
          </a>
        </dd>
        <dd @click="dialogVisible = true">
          <a href="javascript:;">
            <img src="~assets/img3/2.png">
            <p>邀请码</p>
          </a>
        </dd>
        <dd>
          <a href="tel:18580092850">
            <img src="~assets/img3/4.png">
            <p>我的客服</p>
          </a>
        </dd>
      </dl>
    </div>
    <div :style="bool == 1 ? 'height:85px' :'height:65px'"></div>
    <footComponent1 :idx='2' :dx='bool'></footComponent1>
    <el-dialog title="我的邀请码" :visible.sync="dialogVisible" width="85%" top="45%" :show-close="false" :center="true">
      <p style="font-size:30px;text-align:center;padding:20px 0" >
        {{rs.openid}}
        <input type="hidden" id="copy" v-model="bool">
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="copy">复制</el-button>
      </span>
      <img @click="dialogVisible = false" style="position:absolute;bottom:-70px;left:50%;width:35px;transform: translateX(-50%);cursor: pointer;" src="~assets/images/close.png">
    </el-dialog>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        dialogVisible:false,
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        isIphone:false,
        bool:0,
        meImg:require('../../../assets/images/mine.png'),
        code:'',
        rs:[]
      };
    },
    beforeMount() {
      window.removeEventListener("resize", this.handleResize);
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      this.beforeMount();
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent(this.$url+'/main/mjuka');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
        this.getUser();
      }
      
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      copy:function(){
        var Url2=document.querySelector("#copy");
        Url2.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$alert('复制成功！', '提示', {
          confirmButtonText: '确定',
          callback: action =>{
            this.dialogVisible = false
          }
        });
      },
      getUser:function(){
        var that = this;
        that.fullscreenLoading = true
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/mine',
          dataType:'json',
          data:{
            user_id:that.userData.id,
          },
          success:function(data){
            if(data.status == 200){
              that.rs = data.data;
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      
      login:function(){
        var that = this;
        that.$httpWX.post({
          url: that.$hostApi+'home/login/login',
          method:'post',
          data:{
            code:that.code
          }
        }).then(response => {
          if(response.status == 200){
            localStorage.setItem('propertyJwt1', response.data);
            that.getUser();
          }else{
            that.$alert(response.message, '提示');
          }
          that.fullscreenLoading = false;
        })
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  .meApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
    position:relative;
  }
  .meApp .use{
    width:100%;
    height:180px;
    position: relative;
  }
  .meApp .use .useInfo{
    height:70px;
    padding:0 2% 0 4%;
    margin:0 auto 15px auto;
    position: relative;
  }
  .meApp .use .useInfo img.avatar{
    width:66px;
    height:66px;
    border-radius:50%;
    background:#fff;
    padding:2px;
    float:left;
  }
  .meApp .use .useInfo .name{
    float:left;
    width:calc(100% - 78px);
    height:70px;
    margin-left:8px;
    position: relative;
  }
  .meApp .use .useInfo .name h2{
    color:rgba(255,255,255,0.9);
    font-size:24px;
    margin-top:5px;
    width:92%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .meApp .use .useInfo .name p{
    font-size:15px;
    color:rgba(255,255,255,0.9);
    padding-top:8px;
  }
  .meApp .use .useInfo .name p font{
    background: #FFFFFF;
    border-radius: 10px;
    color: #3B97ED;
    font-size:11px;
    display:inline-block;
    height:20px;
    width:70px;
    text-align:center;
    line-height:20px;
  }
  .meApp .use .useInfo .name p font i{
    font-size:13px
  }

  .meApp .use .useInfo .qrcode{
    font-size:12px;
    color:#fff;
    position: absolute;
    right:5px;
    bottom:9px
  }
  .meApp .use .useInfo .qrcode img{
    width:22px;
    height:22px;
    margin:0 auto 5px auto;
    display:block;
  }

  .meApp .use ul{
    width:92%;
    margin:0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .meApp .use ul li{
    width:28%
  }
  .meApp .use ul li span{
    display:block;
    color:rgba(255,255,255,0.9);
    text-align:center;
    font-size:16px
  }
  .meApp .use ul li font{
    display:block;
    text-align:center;
    color:rgba(255,255,255,0.9);
    font-size:20px;
    font-weight:bold;
    padding-top:3px
  }
  .meApp .use .recharge{
    height:70px;
    background:rgba(0,0,0,.5);
    position: absolute;
    bottom:0px;
    width:96%;
    left:2%;
    border-radius: 15px 15px 0 0;
    line-height:70px;
    color:rgb(255,218,83);
    font-size:13px
  }
  .meApp .use .recharge span{
    font-size:18px;
    font-weight:bold;
    padding:0 6px 0 15px;
  }
  .meApp .use .recharge a{
    float:right;
    background:rgb(255,218,83);
    color:#000;
    height:30px;
    line-height:30px;
    width:75px;
    text-align:center;
    font-size:14px;
    border-radius: 30px;
    margin:20px 3% 0 0
  }
  .meApp .money{
    background:#fff;
    width:96%;
    margin:12px auto 0 auto;
    border-radius: 6px;
    padding:10px 0
  }
  .meApp .money:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .meApp .money .left{
    font-size:15px;
    color:#1C222B;
    width:57%;
    float:left;
    line-height:32px;
    padding-left:3%
  }
  .meApp .money .left font{
    color:#f00;
    font-weight:bold;
  }
  .meApp .money .right{
    float:right;
    width:40%;
    text-align:right
  }
  .meApp .money .right a{
    font-size:14px;
    color:#1385FF;
    border:solid 1px #1385FF;
    width:65px;
    height:30px;
    line-height:30px;
    text-align:center;
    display:inline-block;
    border-radius: 30px;
    margin-right:15px
  }
  .meApp .money .right a:first-child{
    margin-left:0
  }

  .meApp .order{
    background:#fff;
    width:96%;
    margin:12px auto 0 auto;
    border-radius: 6px;
  }
  .meApp .order h2{
    height:60px;
    line-height:60px;
    font-size:18px;
    margin:0 auto;
    width:92%;
    border-bottom:solid 1px #f1f1f1
  }
  .meApp .order h2 a{
    float:right;
    font-size:14px;
    font-weight:normal;
    color:#666
  }
  .meApp .order .order-list{
    width:100%;
    margin:0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding:20px 0;
  }
  .meApp .order .order-list .item{
    width:25%;
    position:relative;
  }
  .meApp .order .order-list .item img{
    display:block;
    width:30px;
    margin:0 auto
  }
  .meApp .order .order-list .item p{
    text-align:center;
    font-size:14px;
    color:#616161
  }
  .meApp .order .order-list .item b{
    position: absolute;
    top:-5px;
    width:16px;
    background:rgb(250,69,71);
    color:#fff;
    height:16px;
    border-radius: 50%;
    font-weight:normal;
    font-size:12px;
    text-align:center;
    line-height:16px;
    left:70%;
    transform: translateX(-70%);
  }


  .meApp .server{
    background:#fff;
    width:96%;
    margin:12px auto 0 auto;
    border-radius: 6px;
  }
  .meApp .server h2{
    height:60px;
    line-height:60px;
    font-size:18px;
    margin:0 auto;
    width:92%;
    border-bottom:solid 1px #f1f1f1
  }
  .meApp .server dl{
    display: grid;
    grid-template-columns: repeat(4, 25%);
    padding-bottom:15px
  }
  .meApp .server dl dd{
    margin:25px 0 10px 0
  }
  .meApp .server dl dd a{
    text-decoration: none
  }
  .meApp .server dl img{
    display:block;
    width:50px;
    margin:0 auto
  }
  .meApp .server dl p{
    text-align:center;
    font-size:14px;
    color:#616161
  }
  .meApp .el-dialog{
    border-radius: 10px;
  }
  .meApp .el-dialog .dialog-footer button{
    height: 40px;
    background: #0059D6;
    border-radius: 8px;
    color: #fff;
    font-weight: 500;
    font-size:15px;
    width:45%;
    border-color:#0059D6;
  }
</style>